import {
  ContactFormActionsContext,
  ContactFormDataContext,
  useContactFormActionsFromContext,
  useContactFormDataFromContext,
} from 'src/SharedCommonContext/ContactFormContext';
import Input from 'src/components/Input';
import Row from 'src/components/Row';
import Col from 'src/components/Col';
import React from 'react';

interface ContactAddressProps {
  formType: string;
}

const ContactAddress = ({ formType }: ContactAddressProps) => {
  const {
    contactFormData,
    errors,
    location,
    predictions,
  }: ContactFormDataContext = useContactFormDataFromContext();
  const {
    setContactFormData,
    clearError,
    getLocation,
    onClickLocation,
  }: ContactFormActionsContext = useContactFormActionsFromContext();

  const address = contactFormData.address ?? {};

  if (formType === 'Existing') {
    return null;
  }

  return (
    <>
      <Input
        value={location}
        onChange={(e: any) => getLocation(e.target.value)}
        label="Search Location"
        block
        placeholder="Search Location"
      />
      {predictions.map((item: any, i: number) => (
        <div
          className="location_search"
          onClick={() => onClickLocation(item.description)}
          key={i}
        >
          {item.description}
        </div>
      ))}
      <Input
        value={address.addressLine1 ?? ''}
        onChange={(e: any) =>
          setContactFormData({
            address: { ...address, addressLine1: e.target.value },
          })
        }
        label="Address"
        placeholder="eg., 123 Example Street"
        block
      />
      <Row>
        <Col xs="12" md="4">
          <Input
            value={address.city ?? ''}
            onChange={(e: any) =>
              setContactFormData({
                address: { ...address, city: e.target.value },
              })
            }
            label="City"
            placeholder="eg., Vancouver"
            block
          />
        </Col>
        <Col xs="12" md="4">
          <Input
            value={address.province ?? ''}
            onChange={(e: any) =>
              setContactFormData({
                address: { ...address, province: e.target.value },
              })
            }
            label="Province"
            placeholder="eg., BC"
            block
          />
        </Col>
        <Col xs="12" md="4">
          <Input
            value={address.postalCode ?? ''}
            onChange={(e: any) => {
              clearError('postalCode');
              setContactFormData({
                address: { ...address, postalCode: e.target.value },
              });
            }}
            label="Postal Code"
            placeholder="eg., A0A 0A0"
            block
            errors={errors.postalCode}
          />
        </Col>
      </Row>
    </>
  );
};

export default ContactAddress;
